/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const blue = {
    50: '#E4F7FF',
    100: '#C9EFFF',
    200: '#9CE2FF',
    300: '#7ED9FF',
    400: '#70D5FF',
    500: '#55CDFF',
    600: '#40AFDD',
    700: '#2E91BB',
    800: '#177EA9',
    900: '#0B5F83',
    1000: '#093F55',
};
